// Leaf module: imported by the route registry (pages/corporate/routes), which is
// transitively pulled into _app via useNavigation. Keep this file free of component,
// hook, or icon imports so the registry doesn't drag the ActivityCenter tree into
// every page's module graph.
export enum ActivityCenterTabsEnum {
  NOTIFICATIONS = 'notifications',
  ACTIONS = 'actions',
}
